<template>
  <div id="app">
    <component :is="nav" :key="deviceClass" />
    <router-view v-if="isRouterAlive" />
    <LoginShow />
  </div>
</template>
<script>
import NavTop from '@/components/NavTop/index.vue'
import NavTopH from '@/components/NavTopH/index.vue'
import LoginShow from '@/components/loginShow/index.vue'
import { getBannersAPI } from '@/axios/home'
export default {
  components: { LoginShow, NavTop, NavTopH },
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  computed: {
    nav() {
      if (this.$route.name == 'short' || this.$route.name == 'notFound') {
        return this.deviceClass == 'pc' ? 'NavTop' : 'NavTopH'
      }
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.reload()
      }
    },
  },
  created() {
    // 初始化设备监听
    this.$store.dispatch('device/initResizeListener')
    // 立即更新一次设备状态（处理初始加载）
    this.$store.commit('device/UPDATE_DEVICE_CLASS')
    this.$store.commit('setAttr', {
      name: 'actIndex',
      val: localStorage.getItem('actIndex') || 1,
    })
    // this.getBanners()
  },
  methods: {
    getBanners() {
      getBannersAPI()
        .then(res => {
          if (res.status == 1) {
            this.$store.commit('setAttr', {
              name: 'banner',
              val: res.data,
            })
          }
        })
        .catch(err => {})
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
</style>
